const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('od-modules/utils/tracking.utils');
const fareOptionInfoFactory = require('components/fare_option_info/js/main');

const DEUTSCHE_BAHN = '2A';

const defaultTimeMask = '--:--';

module.exports = BaseView.extend({
    events: {
        'click .flight_info_title': 'onToggleFlightInfoDetails',
    },
    initialize() {
        this.keys = Odigeo._.merge(this.keys, this.options.keys);
        this.render(this.templates[this.options.templateName]);
    },
    buildTime(time, section) {
        return section.timesUndefined ?
            defaultTimeMask : (Odigeo.AB.isUsaTimeFormat)
                ? Odigeo.Utils.formatDate(time, Odigeo.SessionScope.websiteDateFormats.usTimeFormat, true)
                : Odigeo.Utils.formatDate(time, Odigeo.SessionScope.websiteDateFormats.itineraryDetailsTimeFormatMobile, true);
    },
    render(template) {
        const {section, isTechnicalStop, pureTrain, hasTrains, sectionId, index, isResults} = this.options;
        const showDate = this.shouldShowDate(section, index);
        const keys = this.keys;
        const duration = this.calculateDuration(section);
        const cabinClass = keys[Odigeo._.camelCase(section.cabinClass)];
        const carrierLogoUrl = this.calculateCarrierLogoUrl(section);
        const transportLogo = Odigeo.AB.isNewTripDetails
            ? (section.flight ? 'odf-icon-flight-diagonal-colored' : 'odf-icon-train-colored')
            : (section.flight ? 'odf-icon-flight-right' : 'odf-icon-train-right');
        const flightInfoData = {
            section,
            keys,
            duration,
            isTechnicalStop,
            cabinClass,
            carrierLogoUrl,
            transportLogo,
            sectionId,
            hasTrains,
            pureTrain,
        };
        const flightInfoTemplate = this.templates.flightInfo(flightInfoData);
        this.$el.html(template(Odigeo._.extend({
            departure: this.calculateStepData({
                timeProperty: 'technicalStopDep.departureTime',
                timeDefault: this.options.section.departureTime,
                locationProperty: 'technicalStopDep.location',
                locationDefault: this.options.section.departureLocation,
                terminal: this.options.section.departureTerminal,
                technicalStop: this.options.technicalStopDep,
                showDate,
            }),
            arrival: this.calculateStepData({
                timeProperty: 'technicalStopArr.arrivalTime',
                timeDefault: this.options.section.arrivalTime,
                locationProperty: 'technicalStopArr.location',
                locationDefault: this.options.section.arrivalLocation,
                terminal: this.options.section.arrivalTerminal,
                technicalStop: this.options.technicalStopArr,
                showDate,
            }),
            isFlightSummaryImprovementsV1: Odigeo.AB.isFlightSummaryImprovementsV1,
            flightInfo: flightInfoTemplate,
            hideTimeLine: this.options.hideTimeLine,
            alignTitleMargin: this.alignTitleMargin(this.options.alignWithTitle),
            transportLogo,
        }, flightInfoData)));
        if (this.isDeutscheBahnSection(section) && !isResults) {
            fareOptionInfoFactory.create({el: this.$el.find('.fare_option_info')});
        }
    },

    isDeutscheBahnSection({carrier}) {
        return carrier.code === DEUTSCHE_BAHN;
    },

    calculateStepData({timeProperty, timeDefault, locationProperty, locationDefault, terminal, technicalStop, showDate}) {
        const stepTime = Odigeo._.get(this.options, timeProperty, timeDefault);
        const stepTerminal = technicalStop ? null : terminal;
        const stepLocation = Odigeo._.get(this.options, locationProperty, locationDefault);
        const time = this.buildTime(stepTime, this.options.section);
        const date = showDate
            ? Odigeo.Utils.formatDate(stepTime, Odigeo.SessionScope.websiteDateFormats.itineraryDetailsDateFormatMobile, true)
            : '';
        const dateTime = this.fillDateTimeTemplate(date, time, this.options.section);
        const airportInfo = this.fillAirportInfoTemplate(stepLocation, stepTerminal);
        const locationInfo = this.fillLocationInfoTemplate(stepLocation);
        return {
            time,
            date,
            location: stepLocation,
            terminal: stepTerminal,
            airportLocation: this.calculateAirportLocation(stepLocation, stepTerminal),
            airportInfo,
            dateTime,
            locationInfo,
        };
    },

    fillLocationInfoTemplate(location) {
        const {city, country} = location;
        return this.templates.locationInfo({city, country});
    },

    fillAirportInfoTemplate(location, terminal) {
        return this.templates.airportInfo({location, terminal});
    },

    fillDateTimeTemplate(date, time, section) {
        const textInfoClass = section.segmentType === 'DDNT' || section.segmentType === 'DDT' ? 'odf-text-info' : '';
        return this.templates.sectionDateTime({date, time, textInfoClass});
    },
    calculateAirportLocation({airport, city}, terminal) {
        return terminal ? `${airport}, T${terminal}, ${city}` : `${airport}, ${city}`;
    },
    calculateCarrierLogoUrl({carrier}) {
        return Odigeo.Utils.getImageFromCDN(`onefront/airlines/sm${carrier.code}.gif`);
    },
    shouldShowDate({charter, duration}, index) {
        return !charter || (charter && duration !== 0) || (charter && duration === 0 && index === 0);
    },
    calculateDuration({duration}) {
        return Odigeo._.isString(duration) ? duration : Odigeo.Utils.convertMinutesToPattern(duration, this.keys.durationShortPattern);
    },
    alignTitleMargin(alignWithTitle) {
        return alignWithTitle ? 'od-section-flight-space' : '';
    },
    onToggleFlightInfoDetails() {
        const carrrierTitle = this.$el.find('.carrier_info_title');
        this.trackingToggleFlighInfo(carrrierTitle.hasClass('od-flight-info-visible-carrier'));

        carrrierTitle.toggleClass('od-flight-info-visible-carrier');
        setTimeout(() => {
            carrrierTitle.toggleClass('od-flight-info-hidden-carrier');
        }, 400);
    },

    trackingToggleFlighInfo(isOpening) {
        const trackingLabel = isOpening ? 'open_flight_detail' : 'close_flight_detail';
        trackingUtils.trackEvent('flight_detail', trackingLabel);
    },
});
